import React from 'react';

import { bindActionCreators }  from 'redux';
import { connect }  from 'react-redux';

import * as PopupActions from '../actions/popup_actions';
import * as DraftsActions from '../actions/drafts_actions';

import {returnCurrentDraft} from '../reducers/draft_reducer'

import Popup from '../components/Popup.jsx';

class PopupContainer extends React.Component {
    constructor() {
        super();
        this.handleSaveChanges = this.handleSaveChanges.bind(this);
        this.handleEscape = this.handleEscape.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleEscape);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleEscape);
    }

    handleEscape(e){
        if(e.keyCode === 27 && this.props.popup.activePopup) {
            this.handlePopupClose()
        }
    }

    handlePopupClose(){
     const {popupActions} = this.props;
        popupActions.closePopup();
    }

    handleCancelClick(){
        this.handlePopupClose();
    }

    handleSaveChanges(data){
        const {draft, draftsActions} = this.props;
        draftsActions.saveChanges(data.title, data.desc, draft.id)
    }
    
    handleSaveNew(data){
        const {draft, draftsActions} = this.props;
        draftsActions.saveNewCategory(data.title, data.desc)
    }

    render() {
        console.log(this.props);
        return (
            <Popup popupMode={this.props.popup.popupMode} draft={this.props.draft} onCancel={::this.handleCancelClick} onSave={::this.handleSaveChanges} onSaveNew={::this.handleSaveNew}/>
        )
    }
}

function mapStateToProps(state) {
    return {
        popup: state.popup,
        draft: returnCurrentDraft(state.drafts, state.popup.draftID)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        popupActions: bindActionCreators(PopupActions, dispatch),
        draftsActions: bindActionCreators(DraftsActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupContainer);


// WEBPACK FOOTER //
// ./src/_app/drafts/containers/PopupContainer.jsx